import { observer } from "mobx-react-lite";
import React from "react";
import { PlusCircleOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { Button, Drawer, Flex, Space } from "antd";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { ChildEntsButton } from "../ChildEntsButton";
import styles from "./ChildEntsAssign.module.less";
import { ChildEntsAssignStore } from "./ChildEntsAssignStore";

interface PropsChildEntsAssign {
  store: ChildEntsAssignStore;
  isDropdownView: boolean;
  currObjName: string;
  disabled?: boolean;
}

export const ChildEntsAssign: React.FC<PropsChildEntsAssign> = observer(
  ({ store, isDropdownView, currObjName, disabled }) => {
    const {
      loading,
      open,
      assignDisabled,
      filterStore,
      info: assignInfo,
    } = store;
    if (!assignInfo) return null;
    return (
      <>
        <ChildEntsButton
          icon={<PlusCircleOutlined />}
          disabled={disabled}
          onClick={() => store.setOpen(true)}
          isDropdownView={isDropdownView}
        >
          {t("Select")}
        </ChildEntsButton>
        <Drawer
          open={open}
          width="75vw"
          onClose={() => store.onClose()}
          title={
            <Flex align="center" justify="space-between">
              {currObjName}
              <Space>
                <Button onClick={() => store.onClose()} disabled={loading}>
                  {t("Cancel")}
                </Button>
                <Button
                  onClick={() => store.save()}
                  disabled={assignDisabled}
                  loading={loading}
                  type="primary"
                >
                  {t("Select")}
                </Button>
              </Space>
            </Flex>
          }
          className={styles.drawer}
        >
          {filterStore && <EntityFiltersTable store={filterStore} />}
        </Drawer>
      </>
    );
  },
);
